import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import { DataAmigavel } from '@/shared/utils/datas';
import { Link } from 'react-router-dom';
import { LotacaoService } from '@/modules/business/lotacoes/lotacao.service';
import { Modal, Button } from 'react-bootstrap';
import { ReadLotacaoDto } from '@/api.types';
import { SearchDtoLotacoes } from '@/shared/types/search.dto';
import { TipoLotacaoList, TipoLotacaoEstagioList } from '@/shared/constants/enumlist';
import { toast } from 'react-toastify';
import { useEffect, useState, useMemo } from 'react';

type TipoPessoa = 'defensor' | 'colaborador' | 'estagiario';

interface IMyProps {
  show: boolean;
  handleHide: () => void;
  tipoPessoa: TipoPessoa;
  pessoaId: number;
  pessoaNome: string;
}

const TIPO_LOTACAO_LIST = TipoLotacaoList.concat(TipoLotacaoEstagioList);

export default function ModalLotacoesPessoa({
  show,
  handleHide,
  tipoPessoa,
  pessoaId,
  pessoaNome,
}: IMyProps) {
  const lotacaoService = useMemo(() => new LotacaoService(), []);
  const [lotacoes, setLotacoes] = useState<ReadLotacaoDto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!show || !pessoaId) return;

    setLoading(true);

    const conditions: SearchDtoLotacoes = {
      skip: 0,
      take: 1000,
      id_defensoria: 0,
      id_nucleo: 0,
      id_defensor: 0,
      id_setor: 0,
      id_estagiario: 0,
      id_colaborador: 0,
      somente_ativas: false,
      vigente: false
    };

    if (tipoPessoa === 'defensor') {
      conditions.id_defensor = pessoaId;
    } else if (tipoPessoa === 'colaborador') {
      conditions.id_colaborador = pessoaId;
    } else if (tipoPessoa === 'estagiario') {
      conditions.id_estagiario = pessoaId;
    }

    lotacaoService
      .Enumerate(conditions)
      .then((result) => {
        setLotacoes(result[0]);
      })
      .catch((error) => {
        toast.error('Erro ao carregar lotações.');
        console.error('Erro ao carregar lotações:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [show, pessoaId, tipoPessoa, lotacaoService]);

  const getTipoLotacaoNome = (tipo: number) => {
    return TIPO_LOTACAO_LIST.find((t) => t.value === tipo)?.name || '-';
  };

  const getLocalNome = (lotacao: ReadLotacaoDto) => {
    return lotacao.defensoria?.nome || lotacao.nucleo?.nome || lotacao.setor?.nome || '-';
  };

  const isVigente = (lotacao: ReadLotacaoDto) => {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const dataInicial = lotacao.data_inicial ? new Date(lotacao.data_inicial) : null;
    const dataFinal = lotacao.data_final ? new Date(lotacao.data_final) : null;

    if (dataInicial) dataInicial.setHours(0, 0, 0, 0);
    if (dataFinal) dataFinal.setHours(0, 0, 0, 0);

    const inicioOk = !dataInicial || dataInicial <= hoje;
    const fimOk = !dataFinal || dataFinal >= hoje;

    return lotacao.ativo && inicioOk && fimOk;
  };

  return (
    <Modal
      show={show}
      size="xl"
      aria-labelledby="modal-lotacoes-pessoa"
      centered
      onHide={handleHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="modal-lotacoes-pessoa">
          Vínculos de {pessoaNome}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Loading />
        ) : lotacoes.length === 0 ? (
          <p className="text-muted text-center">Nenhum vínculo encontrado.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Local</th>
                  <th>Setor</th>
                  <th>Início</th>
                  <th>Fim</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {lotacoes.map((lotacao) => {
                  const vigente = isVigente(lotacao);
                  return (
                    <tr key={lotacao.id} className={!vigente ? 'text-muted' : ''}>
                      <td>{getTipoLotacaoNome(lotacao.tipo)}</td>
                      <td>{getLocalNome(lotacao)}</td>
                      <td>{lotacao.setor?.nome || '-'}</td>
                      <td>{DataAmigavel(lotacao.data_inicial)}</td>
                      <td>{DataAmigavel(lotacao.data_final)}</td>
                      <td>
                        {vigente ? (
                          <span className="badge bg-success">Vigente</span>
                        ) : (
                          <span className="badge bg-secondary">Encerrada</span>
                        )}
                      </td>
                      <td>
                        <Link className="link-secondary" to={`${Links.Vinculos_Editar}/${lotacao.id}`} onClick={handleHide} target='_blank'>
                          Editar
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

